<script >
export default {
  name: 'saleOutletSite',
  data() {
    return {
      searchSiteId:'',
      page1: 1,//当前页
      size1: 20,//每页条数
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      inList: [
        {
          siteId:'54010001',
          userName:'张丹',
          saleNumber:23434,
          address:'西藏拉萨城关太阳宫',
          top:1
        },{
          siteId:'54010001',
          userName:'张丹',
          saleNumber:23434,
          address:'西藏拉萨城关太阳宫',
          top:2
        },{
          siteId:'54010001',
          userName:'张丹',
          saleNumber:23434,
          address:'西藏拉萨城关太阳宫',
          top:3
        },{
          siteId:'54010001',
          userName:'张丹',
          saleNumber:23434,
          address:'西藏拉萨城关太阳宫',
          top:4
        }
      ],
    }
  },
  methods:{
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    getBack(){
      this.$router.push({path: '/saleStatistic'});
    }
  },
  created() {

  }
}
</script>

<template>
  <div class="container">
    <div class="header-one">
<!--      <div class="header-title"><van-icon @click="getBack" name="arrow-left" class="font" />网点销量查询</div>-->
      <!--   网点编号 搜索-->
      <div class="search-group">
        <div class="search-item">
          <van-field
              v-model="searchSiteId"
              name="name"
              label=""
              type="number"
              autocomplete="off"
              placeholder="输入网点编号查询"
          />
<!--          <van-button block type="primary" class="btn-search" color="#e62d2d">搜索</van-button>-->
        </div>
      </div>
    </div>
    <div class="content">
      <van-list v-model="loading1" :finished="finished1"  :finished-text="finishedMsgTxt" :immediate-check="false"
                @load="onLoad">
      <div class="outlet-card" v-for="(item,index) in inList" :key="index">
        <div class="outlet-header">
          <div class="outlet-info">
            <div class="outlet-number">
              <van-icon name="shop" /> {{item.siteId}}
            </div>
            <div class="outlet-address">
              <van-icon name="location" />
              {{ item.address }}
            </div>
          </div>
          <div class="outlet-sales-badge">
            <div class="sales-amount"><span class="sales-unit">销量：</span>{{ item.saleNumber }}<span class="sales-unit">万</span></div>
          </div>
        </div>
        <div class="outlet-footer">
          <div class="footer-item">
            <van-icon name="contact" />站主：<span class="footer-value">{{ item.userName }}</span>
          </div>
          <div class="footer-item">
            <van-icon name="award" /><span class="rank-badge">第{{item.top}}名</span>
          </div>
        </div>
      </div>
      </van-list>
      <div class="no-result" v-if="inList.length===0">
        <i class="fas fa-search"></i>
        <p>未找到相关网点</p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  padding-top: 90px;
  box-sizing: border-box;
}
.header-one {
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #e62d2d, #a30c0c);
  color: white;
  padding: 0 20px;
  width: 100%;
  text-align: center;
  //position: sticky;
  //top: 0;
  //z-index: 100;
  box-shadow:0 4px 12px rgba(0,0,0,0.1);
  .header-title {
    display: block;
    width: 100%;
    padding: 20px 0 0 0;
    text-align: center;
    font-weight: bold;
    .font{
      position: absolute;
      left: 0;
      top: 0;
      color: #fff;
      font-size: 40px;
      margin: 20px;
    }
  }
  .search-group{
    display: flex;
    width: 100%;
    flex-flow: column;
    padding: 20px 0;
    .search-item{
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      gap: 10px;
      .van-cell{
        border-radius: 50px;
      }
      .btn-search{
        width: 200px;
        font-size: 24px !important;
        padding: 10px;
      }
    }
  }
}
.back-btn {
  position: absolute;
  left: var(--spacing-md);
  top: 68%;
  transform: translateY(-50%);
  color: white;
  font-size: 16px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 8px;
}
.search-box {
  position: relative;
  width: 90%;
  float: right;
}
.search-input {
  width: 100%;
  padding: 12px 45px 12px 40px;
  border: none;
  border-radius: 25px;
  font-size: 15px;
  background-color: rgba(255,255,255,0.95);
  transition: all 0.3s;
}
.search-input:focus {
  outline: none;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-light);
}
.clear-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-light);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  display: none;
  padding: 4px;
}
.content {
  flex: 1;
  padding: 20px 20px 0;
}

.outlet-card {
  background: linear-gradient(to right, #ffffff 0%, #fafafa 100%);
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: var(--shadow-sm);
  border-left: 4px solid var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.outlet-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, transparent 50%, rgba(230, 45, 45, 0.05) 50%);
}

.outlet-card:active {
  transform: translateY(2px);
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.outlet-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.outlet-info {
  flex: 1;
}

.outlet-number {
  font-weight: bold;
  color: var(--text-dark);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}

.outlet-number i {
  font-size: 34px;
  margin-right: 8px;
  color: var(--primary-color);
}

.outlet-address {
  color: var(--text-light);
  display: flex;
  align-items: center;
  margin-top: 4px;
}

.outlet-address i {
  font-size: 34px;
  margin-right: 6px;
  color: var(--text-light);
}

.outlet-sales-badge {
  color: var(--primary-color);
  padding: 0 0 8px 0;
  text-align: center;
}

.sales-label {
  opacity: 0.9;
  margin-bottom: 2px;
}

.sales-amount {
  font-weight: bold;
  line-height: 1;
  font-size: 40px;
}

.sales-unit {
  margin-left: 2px;
}

.outlet-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid rgba(0,0,0,0.06);
}

.footer-item {
  display: flex;
  align-items: center;
  color: var(--text-light);
}

.footer-item i {
  font-size: 34px;
  margin-right: 6px;
  color: var(--primary-color);
}

.footer-value {
  color: var(--text-dark);
  font-weight: 600;
  margin-left: 4px;
}

.rank-badge {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(255, 165, 0, 0.3);
}

.rank-badge.top-3 {
  background: linear-gradient(135deg, #FFD700, #FF8C00);
}

.no-result {
  text-align: center;
  padding: 80px 20px;
  color: var(--text-light);
}

.no-result i {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.2;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-light));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.no-result p {
  font-size: 25px;
}

.chevron-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-light);
  opacity: 0.5;
}
</style>